import { EmptyProps } from '@core/components/empty/empty.component';
import { EContentPanelRoute, IContentFilterBlock } from 'lingo2-models';
import { Subject as BaseSubject } from 'lingo2-models/dist/content/subject';

export const schoolTabs: IContentFilterBlock[] = [
  {
    order: 1,
    id: 1,
    title: 'school-main-tabs.main',
    code: EContentPanelRoute.main,
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 2,
    id: 2,
    title: 'school-main-tabs.tutors',
    code: 'school-tutors',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 3,
    id: 3,
    title: 'school-main-tabs.classes',
    code: 'school-classes',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 4,
    id: 4,
    title: 'school-main-tabs.feed',
    code: 'feed',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 5,
    id: 5,
    title: 'school-main-tabs.educational-material',
    code: 'educational-material',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 6,
    id: 6,
    title: 'school-main-tabs.feedback',
    code: 'feedback',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
];

export const emptyTutorsContent: Partial<EmptyProps> = {
  title: 'school-main-tabs.tutors',
  text: 'school-placeholder.tutors.text',
  link: 'settings/set-teacher',
  link2: 'settings/set-teacher',
  link_label: 'school-placeholder.tutors.link',
  image: 'tutors',
};

export const emptyClassesContent: Partial<EmptyProps> = {
  title: 'school-main-tabs.classes',
  text: 'school-placeholder.classes.text',
  link: 'settings/classes',
  link2: 'settings/classes',
  link_label: 'school-placeholder.classes.link',
  image: 'classes',
};

export const emptyLessonsContent: Partial<EmptyProps> = {
  title: 'school-main-tabs.educational-material',
  text: 'school-placeholder.lessons.text',
  link_label: 'school-placeholder.lessons.link',
  image: 'lessons',
  action: true,
};

export const emptyFeedbackContent: Partial<EmptyProps> = {
  title: 'school-main-tabs.feedback',
  text: 'school-placeholder.feedback.text',
  image: 'comments',
};
